import type { NewCustomDimension } from "domains/dimension/dimension.types";
import type { Topic } from "entities/topics/types";

export type CreateMapState = {
  AIGeneratedMapErrorCode: number | null;
  AIGeneratedMapProgress: AIGeneratedMapProgress;
  data?: Partial<Omit<Topic, "dimensions"> & { dimensionIds: string[] }>;
  description: string;
  image?: string;
  isAIGeneratedMapFetching: boolean;
  isAIGeneratedModeOn: boolean;
  isDraggingKeyIssue: boolean;
  isPending: boolean;
  keyIssueIds: string[];
  name: string;
  newCustomKeyIssues: NewCustomDimension[];
};

export type LocalImage = { file: Blob; url: string };
export type LocalFile = { file: File; url: string };
export type UploadMapMeta = { closeEditor?: boolean; pathname: string };

export enum FakeProgressStatuses {
  "Not started" = "Not started",
  "Preparing" = "Preparing",
  "Selecting" = "Selecting",
  "Finalizing" = "Finalizing",
  "Finish" = "Finish",
}

export type AIGeneratedMapProgress = { status: FakeProgressStatuses };
